module.exports = __webpack_public_path__ + "static/img/20.1ac22178.jpg";